import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, ListPagination } from '../../../../../../components/UI/ComponentsUI';
import { translate, groupBy } from '../../../../../../utils/util';
import { ENUMS } from '../../../../../../utils/constants';
import DeliveryService from '../../../../../../services/DeliveryService';
import ConfirmModalDelivery from './ConfirmModalDelivery';
import * as deliveryAction from '../../../../../../actions/deliveryAction';

const ListOrderMission = (props) => {
    const messageModal = useRef();
    const [currentPage, setCurrentPage] = useState(0);
    const [items, setItems] = useState([]);
    const [group, setGroup] = useState([]);

    useEffect(() => {
        props.setNextListPdu(false);

        return () => {
            props.getGroupUser();
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const array = [];
        if (props.orders) {
            props.orders.forEach(element => {
                const item = element.items[0];
                item.orderCode = element.orderCode;
                item.frame = element.frameQrCode;
                item.key = `${item.partnumber}+${element.frameQrCode.qrCode}`;
                array.push(item)
            });
        }
        setItems(array);

        const arrayFinal = groupBy(array, 'key');
        setGroup(arrayFinal);

        // eslint-disable-next-line
    }, [props.orders, props.groupDelivery]);

    const checkItemInProgress = (list) => {
        let filter = {
            orderItemIds: [],
            check: false
        }
        const itensCheck = list.filter((f) => f.status === ENUMS.eOrderItemStatus.InProgress.value);
        filter.check = itensCheck.length !== list.length;

        list.forEach((item) => {
            if (item.status !== ENUMS.eOrderItemStatus.Finished.value && item.status !== ENUMS.eOrderItemStatus.WaitingFinish.value) {
                filter.orderItemIds.push(item.orderItemId);
            }
        });

        props.checkedItem(filter, () => {
            if (isValidItems()) {
                openModal();
            }
        });
    }

    const checkStatus = (list) => {
        var filter = list.filter((item) => item.status === ENUMS.eOrderStatus.Waiting.value);
        if (filter.length > 0) {
            return 'gray';
        } else {
            return 'green';
        }
    }

    const openModal = () => {
        const modal = messageModal.current;
        modal.show();
        modal.focus();
    }

    const isValidItems = () => {
        const itensCheck = items.filter((f) => f.status === ENUMS.eOrderItemStatus.InProgress.value)?.length || 0;
        const itensFinish = items.filter((f) => f.status === ENUMS.eOrderItemStatus.Finished.value || f.status === ENUMS.eOrderItemStatus.WaitingFinish.value)?.length || 0;

        if (itensCheck > 0 && (itensCheck + itensFinish) === items.length) {
            return true;
        }
        return false;
    }

    const onConfirmModal = (nextLocation, callbackModal) => {
        if (props?.orders[0]?.items[0].nextLocation === nextLocation) {
            props.confirmation(nextLocation, () => {
                if (callbackModal) {
                    callbackModal();
                    props.setNextListPdu(true);
                    return props.history.go(-1);
                }
            })
        }
    }

    const sumQtdItems = (item) => {
        try {
            var total = 0;
            for (var i in item.value) {
                total += item.value[i]?.quantity || 0;
            }
            return total;
        } catch {
            return false;
        }
    }

    const orderCodeJoin = (item) => {
        try {
            var orderCodes = [];
            item.value.forEach(element => {
                orderCodes.push(element.orderCode);
            });
            return orderCodes.join(", ");
        } catch {
            return "";
        }
    }

    return (
        <div>
            <Breadcrumbs id="deliveryPduTitle" title={{ icon: "mdi mdi-camera-timer", label: translate('title', 'delivery') }}
                subtitles={[{ icon: "business_center", label: translate('delivery:fields.pdu') }]} />
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div className="col s12 subtitle">
                    <span style={{ marginLeft: '1px', display: 'inline-flex' }}>
                        {translate('delivery:fields.pdu')}: {props?.orders[0]?.items[0].nextLocation || ''}
                    </span>
                </div>
                <div id="listOrdersMissionDelivery">
                    <ListPagination
                        page={0}
                        current={{ currentPage, setCurrentPage }}
                        data={group.map((item) => (
                            <>
                                <span
                                    className="title sixth-text-color right"
                                    style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                                ><i onClick={() => {
                                    checkItemInProgress(item.value);
                                }} className={`mdi mdi-48px mdi-checkbox-marked-circle-outline ${checkStatus(item.value)}-text`} />
                                </span>
                                <div className="row" style={{ display: 'block', marginBottom: '0px' }} >
                                    <span className="title sixth-text-color" style={{ marginLeft: '10px' }} >
                                        {`${item.key.split('+')[0] || ''}`}
                                    </span>
                                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                        {`${item.value[0].description || ''}`}
                                    </span>
                                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                        {`${item.key.split('+')[1] || ''}`}
                                    </span>
                                    <div>
                                        <span className="second-text-color" style={{ marginLeft: '10px' }}>
                                            Chamada(s): {`${orderCodeJoin(item) || ''}`}
                                        </span>
                                    </div>
                                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                        {translate('delivery:fields.quantityBox')}: {`${item.value.length || ''}`}
                                    </span>
                                    <span className="truncate second-text-color" style={{ marginLeft: '10px', paddingBlockEnd: '10px' }}>
                                        {translate('delivery:fields.quantityParts')}: {`${sumQtdItems(item) || ''}`}
                                    </span>
                                </div>
                            </>
                        ))}
                    />
                </div>
                {
                    isValidItems() && (<div className="row" style={{ marginBottom: '0px' }}>
                        <button
                            type="button"
                            className="col s12 m3 btn btn-principal waves-effect waves-light"
                            style={{ width: '100%' }}
                            onClick={() => openModal()}
                        >
                            {translate('delivery:general.finish')}
                        </button>
                    </div>)
                }
            </div>
            <ConfirmModalDelivery
                ref={messageModal}
                id="confirmModalDelivery"
                data={{ title: translate('validations:attention'), message: `${translate('delivery:message.confirmNextPdu')} ${props?.orders[0]?.items[0].nextLocation || ''}` }}
                onConfirm={onConfirmModal}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        groupDelivery: state.deliveryReducer.deliveryGroup,
        orders: state.deliveryReducer.orders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkedItem: (items, callback) => {
            dispatch(DeliveryService.checkedItem(items, callback));
        },
        confirmation: (item, callback) => {
            dispatch(DeliveryService.ConfirmationDeliveryPdu(item, callback));
        },
        setNextListPdu: (nextPdu) => {
            dispatch(deliveryAction.setNextPdu(nextPdu));
        },
        getGroupUser: (callback) => {
            dispatch(DeliveryService.getGroupUser(callback))
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListOrderMission)));
